import { businessPlanAxios } from 'services/controllers/businessPlan';

import * as t from './types';

export const BusinessToolFormApi = {
  getAllChapters: async (businessPlanId: string) => {
    const { data } = await businessPlanAxios.get<t.IBusinessPlanChaptersResponse>(`${businessPlanId}/chapters`);
    return data;
  },

  updateChapter: async ({ id, body }: t.IUpdateBusinessPlanChapterParams) => {
    // TODO revert to this in case of 500 error on document save
    //const { data } = await businessPlanAxios.patch<t.IUpdateBusinessPlanChapterResponse>(`${id}/chapters`, [body]);
    const { data } = await businessPlanAxios.patch<t.IUpdateBusinessPlanChapterResponse>(`${id}/chapter`, body);
    return data;
  },
};
